import { useDispatch, useSelector } from "react-redux";
import styles from "./PaymentOverviewModal.module.scss";
import { RootState } from "../../../../../../stores/store";
import Button from "../../../../../../common/components/xepp/button/Button";
import { useAddNewServiceRequestMutation, useEditServiceRequestMutation } from "../../../../../../service/customersupport-service";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../../../../../utils/error-handler";
import { useLocation, useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../../../../routes";
import { resetState } from "../../../../../../stores/slices/service-type-slice";
import { Money } from "../../../../../../model/common/money";

type Props = {
	onModalClose: () => void;
};

const PaymentOverviewModal = (props: Props) => {
	const currentState = useSelector((state: RootState) => state.serviceType);
	const navigator = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();

	const [addNewServiceRequest, { isLoading: isAdding }] = useAddNewServiceRequestMutation();
	const [editServiceRequest, { isLoading: isEditing }] = useEditServiceRequestMutation();

	const onContinueClick = () => {
		const isEdit = location.pathname.includes(ApplicationRoutes.EDIT);
		if (isEdit) {
			editServiceRequest({
				serviceRequestId: currentState.id,
				name: currentState.name,
				description: currentState.description,
				sectionDefinitions: currentState.sectionDefinitions,
				price: currentState.price,
				payOnSubmit: currentState.payOnSubmit,
				isExternal: currentState.isExternal,
			})
				.unwrap()
				.then(() => {
					toast.success("Service Request edited successfully.");
					dispatch(resetState());
					navigator(`/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.SERVICE_REQUEST}`);
				})
				.catch(err => {
					toast.error(getErrorMessage(err?.data));
				});
			return;
		}

		addNewServiceRequest(currentState)
			.then(() => {
				toast.success("Service Request added successfully.");
				dispatch(resetState());
				navigator(`/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.SERVICE_REQUEST}`);
			})
			.catch(err => {
				toast.error(getErrorMessage(err?.data));
			});
	};

	return (
		<div className={styles.modalOverlay} onClick={() => console.log("backdrop click")}>
			<div className={styles.modalContent} onClick={e => e.stopPropagation()}>
				<div className={styles.headerWrapper}>
					<span>{currentState.name}</span>
					<button className={styles.closeBtn} onClick={() => props.onModalClose()}>
						×
					</button>
				</div>
				<div className={styles.bodyContainer}>
					<div className={styles.infoRow}>
						<span>Service Request Type</span>
						<span>{currentState.name}</span>
					</div>
					{!currentState.isPaymentRequired && (
						<div className={styles.infoRow}>
							<span>Service Type Payment Amount</span>
							<span>Free</span>
						</div>
					)}
					{currentState.isPaymentRequired && !currentState.isPaymentPerSubtype && currentState.price && (
						<div className={styles.infoRow}>
							<span>Service Type Payment Amount</span>
							<span>{new Money(currentState.price).toLocaleString()}</span>
						</div>
					)}
					{currentState.isPaymentRequired &&
						currentState.isPaymentPerSubtype &&
						currentState.sectionDefinitions.flatMap((section, i) =>
							section.attributeDefinitions.map((field, index) =>
								field.childrenOptionDefinitions?.map((optionDefinition, optionIndex) => {
									return (
										optionDefinition.price && (
											<div key={`field-${index}-option-${optionIndex}`} className={styles.infoRow}>
												<span>{optionDefinition.value}</span>
												<span>{new Money(optionDefinition.price).toLocaleString()}</span>
											</div>
										)
									);
								})
							)
						)}
					{currentState.isPaymentRequired && (
						<div className={styles.infoRow}>
							<span>When should the payment be collected?</span>
							<span>{currentState.payOnSubmit ? "When user submit service request" : "Payment determined on workflow"}</span>
						</div>
					)}
				</div>
				<div className={styles.footerWrapper}>
					<Button disabled={isAdding || isEditing} text={"Continue"} onClick={onContinueClick} variant={"secondary"} />
				</div>
			</div>
		</div>
	);
};

export default PaymentOverviewModal;
